export type BackofficeRole = {
    readonly id: string,
};

export type BackofficeSsuPermission = 'all' | string[];

export const BACKOFFICE_ROLE_VIEWER = {
    id: 'Viewer',
} as const satisfies BackofficeRole;

export const BACKOFFICE_ROLE_STANDARD = {
    id: 'Standard',
} as const satisfies BackofficeRole;

export const BACKOFFICE_ROLES = [
    BACKOFFICE_ROLE_VIEWER, BACKOFFICE_ROLE_STANDARD
] as const;
